exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3 {\n  padding-top: 30px;\n}\n.centerWrapper {\n  margin-top: 30px;\n  background-color: white;\n  padding: 40px;\n  border-radius: 8px;\n}", ""]);

// exports
